import { render } from "./CustomerInformations.vue?vue&type=template&id=164c5ab1"
import script from "./CustomerInformations.vue?vue&type=script&lang=js"
export * from "./CustomerInformations.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./CustomerInformations.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_c2bd7943%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2Fplan_sales%2FCustomerInformations.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__